import { render } from "./BlogSidebarHollywoodSmile.vue?vue&type=template&id=56b7da6c"
import script from "./BlogSidebarHollywoodSmile.vue?vue&type=script&lang=js"
export * from "./BlogSidebarHollywoodSmile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__